import React, { Component } from 'react'
import { InputSearchLayout, PageContainerLayout, PageHeaderLayout, PaginationLayout } from '../../../layouts'
import { PermissionsHeaderTiles, PermissionsTable } from '../../../shared/containers'
import { permissionOperations } from '../../../../state/ducks/permissions'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { PaginationShape, PermissionShape } from '../../../../prop-types'

class PermissionsPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      params: {}
    }
    this.fetchPermissions = this.fetchPermissions.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.updateParams = this.updateParams.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.fetchPermissions()
  }

  fetchPermissions () {
    this.props.fetchPermissions(this.state.params)
  }

  onPaginationChange (page) {
    this.updateParams('page', page)
  }

  onSearchChange (keywork) {
    this.updateParams('search', keywork)
  }

  updateParams (key, value) {
    const { params } = this.state
    params[key] = value
    if (key === 'search') {
      params.page = 1
    }
    this.setState({
      params
    }, () => this.fetchPermissions())
  }

  renderHeaderPaths () {
    return (
            <>
                <li>Permissions</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout title={'Permissions'} subTitle={'All permissions'}
                                      paths={this.renderHeaderPaths}/>
                    {/* Page Content */}
                    <div className="content content-boxed">
                        {/* Header Tiles */}
                        <PermissionsHeaderTiles all_permissions={this.props.paginationData.totalItems}/>
                        {/* END Header Tiles */}
                        <div className={' block block-themed block-opt-refresh-icon7 ' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                            <div className="block-header bg-primary-dark">
                                <ul className="block-options">
                                    <li>
                                        <button type="button"
                                                data-toggle="block-option"
                                                data-action="refresh_toggle"
                                                data-action-mode="demo"
                                                onClick={this.fetchPermissions}
                                        >
                                            <i className="si si-refresh"/>
                                        </button>
                                    </li>
                                </ul>
                                <h3 className="block-title">All permissions</h3>
                            </div>
                            <div className="block-content">
                                {/* Search */}
                                <InputSearchLayout onSearchChange={this.onSearchChange}/>
                                {/* End Search */}
                                {/* Table */}
                                <PermissionsTable permissions={this.props.permissions}>
                                    {/* Pagination */}
                                    <PaginationLayout pagination={this.props.paginationData}
                                                      onPaginationChange={this.onPaginationChange}/>
                                    {/* End Pagination */}
                                </PermissionsTable>
                                {/* End Table */}
                            </div>
                        </div>
                    </div>
                    {/* END Page Content */}
                </PageContainerLayout>
            </>
    )
  };
}

// Set propTypes
const { arrayOf, func } = PropTypes
PermissionsPage.propTypes = {
  permissions: arrayOf(PermissionShape).isRequired,
  fetchPermissions: func.isRequired,
  paginationData: PaginationShape
}

// Set defaultProps
PermissionsPage.defaultProps = {
  permissions: [],
  paginationData: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  isLoading: state.permissions.fetchPermissionsReducer.loading,
  permissions: state.permissions.fetchPermissionsReducer.data.results,
  paginationData: state.permissions.fetchPermissionsReducer.data.pagination_data
})

// mapStateToProps
const mapDispatchToProps = {
  fetchPermissions: permissionOperations.list
}

// Export Class
const _PermissionsPage = connect(mapStateToProps, mapDispatchToProps)(PermissionsPage)
export { _PermissionsPage as PermissionsPage }
